import _isArray from 'lodash/isArray';

import { orderServiceTerminalStatuses } from 'utils/DICTIONARY';

export default function hasRequestTerminated(osStatus) {
  const terminalStatuses = orderServiceTerminalStatuses();
  return _isArray(terminalStatuses) && terminalStatuses.includes(osStatus);
}
